<template>
  <div>
    <bank-details-form
      ref="bankDetailsForm"
      @submit="handleSubmit"
      @update:isInvalid="handleUpdateIsInvalid"
      :initialValues="values"
    >
      <div
        v-if="$slots.default"
        class="actions"
      >
        <slot />
      </div>
    </bank-details-form>
  </div>
</template>
<script>
import BankDetailsForm from '@/components/project/globals/BankDetailsForm.vue'
export default {
  name: 'BankDetailsStep',
  components: {
    BankDetailsForm
  },
  props: {
    initialValues: Object
  },
  data () {
    return {
      values: {}
    }
  },
  methods: {
    handleSubmit (values) {
      this.$emit('submit', values)
    },
    handleUpdateIsInvalid (value) {
      this.$emit('update:isInvalid', value)
    }
  },
  created () {
    this.values = this.initialValues
  }
}
</script>

<style scoped>
.actions {
  display: flex;
  flex-direction: row-reverse;
}
</style>
